





































































































































































































import BaseFilter from "@/components/Filter/BaseFilter";
import {
  SelectWings,
  FastDateDetailWings,
  DatePickerWings,
  NumberWings,
  InputWings
} from "wings-ui-components";
import { DetailIncomingFilterParams } from "@/store/statistics/types";
import { Component, Prop, PropSync, Watch } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import { notifyError, notifyWarning } from "@/utils/notify-helper";
import {
  beginningOfCurrentDay,
  currentDateEnd,
  dateFilter,
} from "@/utils/date-util";
import { ServiceProviderItem } from "@/store/settings/service_providers/types";
import { MsgTransports } from "@/store/types";
import {getTranslatedParams} from "@/utils/notify-utils";
import {ActionLog} from "@/store/auth/types";

@Component({
  components: {
    SelectWings,
    FastDateDetailWings,
    DatePickerWings,
    NumberWings,
    InputWings
  },
  filters: { dateFilter },
})
export default class DetailIncomingFilter extends BaseFilter<DetailIncomingFilterParams> {
  @Prop() transport!: MsgTransports;
  @PropSync("show") is_show!: boolean;
  @PropSync("filterClone") propFilterClone!: DetailIncomingFilterParams;
  @PropSync("runFilter") propRunFilter!: boolean;

  @Getter("smsMessagesStatusList") statusList!: string[];

  @Action("getStatisticDetailIncoming") actionGetItems: any;
  @Action("exportStatisticDetailIncoming") actionExport: any;
  @Action("getPartners") actionGetPartners: any;
  @Action("getServiceProviders") actionGetServiceProviders: any;
  @Action("getAccounts") actionGetAccounts: any;
  @Action("actionLog") actionLog: any;

  defaultFilter(): DetailIncomingFilterParams {
    return new DetailIncomingFilterParams(
      beginningOfCurrentDay(),
      currentDateEnd()
    );
  }

  params = {transport: this.transport}
  partnersList: any = []
  accountsList: any = []
  serviceProvidersList:  any = []

  filterKeys: object = {
    "originator": "addresser",
    "recipient" : "service_no",
    "broker_account_login" : "account"
  }

  async getPartnersList(filter: any) {
    const items = await this.actionGetPartners({...this.params, ...filter});
    this.partnersList = (filter?.page_number > 1) ? this.partnersList.concat(items) : items
  }

  async getAccountsList(filter: any) {
    const items = await this.actionGetAccounts({...this.params, ...filter});
    this.accountsList = (filter?.page_number > 1) ? this.accountsList.concat(items) : items
  }

  async getServiceProvidersList(filter: any) {
    const items = await this.actionGetServiceProviders({...this.params, ...filter});
    this.serviceProvidersList = (filter?.page_number > 1) ? this.serviceProvidersList.concat(items) : items
  }

  async created() {
    this.scroll()
    if (this.filter.partner) this.partnersList = await this.actionGetPartners({name: this.filter.partner});
    if (this.filter.broker_account_login) this.accountsList = await this.actionGetAccounts({login: this.filter.broker_account_login});
    if (this.filter.service_provider) this.serviceProvidersList = await this.actionGetServiceProviders({name: this.filter.service_provider});
  }

  async onFilteredAction(nextPage = false) {
    if (!nextPage) this.filter.page_number = 1;
    try {
      this.logObject = {
        action_page: this.$route.meta.msgKey,
        action: "Viewing",
        action_status: "success",
        object_type: "Detail statistics of incoming messages",
        addititional_info: getTranslatedParams(this.filter, this.filterKeys)
      };
      const resp = await this.actionGetItems({filter: this.filter, transport: this.transport});
      await this.actionLog(this.logObject);
      if (resp.status == 204) {
        this.is_last = true
        if (!nextPage) notifyWarning()
      } else {
        this.is_last = false
      }
    } catch (err) {
      await this.actionLog({...this.logObject, action_status: "failed"});
      notifyError(err);
    } finally {
      this.moreLoading = false;
    }
  }

  async doActionExport(filter: any): Promise<any> {
    return await this.actionExport({
      filter: filter,
      transport: this.transport,
    });
  }

  @Watch("filter", { immediate: true, deep: true })
  onFilterChange(newVal: DetailIncomingFilterParams) {
    this.propFilterClone = newVal;
  }

  @Watch("runFilter", { immediate: true })
  onRunFilterChange(val: boolean) {
    if (val) {
      this.filtered();
      this.propRunFilter = false;
    }
  }
}
